import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function Accessoires({navigateWithTransition}) {




return (

<div className="Accessoires">




</div>

)

}